// extracted by mini-css-extract-plugin
export default {"flex":"app_flex__nzDZQ","form":"app_form__csLjb"};